class ChaveAcessoModalController {
    constructor(api, empresaId, modalInstance) {
        this.api = api
        this.modalInstance = modalInstance

        this.promise = this.loadChave(empresaId)
    }

    async loadChave(empresaId) {
        let { data: { hash } } = await this.api.post('/usuarios/chave-acesso', {empresa_id: empresaId})

        this.chaveAcesso = hash
    }

    close() {
        this.modalInstance.dismiss()
    }
}

angular.module('eficienciaFiscalModule')
    .controller('chaveAcessoModalController', ['api', 'contrato', '$uibModalInstance', ChaveAcessoModalController])